import { render, staticRenderFns } from "./ForumCreationDialog.vue?vue&type=template&id=0021657b"
import script from "./ForumCreationDialog.vue?vue&type=script&lang=ts"
export * from "./ForumCreationDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports